import {ConversationDevBadge} from '@stripe-internal/conversations-ui';

import {useCurrentConversation} from '../../../core/hooks/appHooks';

export function HeaderBadge() {
  const conversation = useCurrentConversation();

  if (!conversation) {
    return null;
  }

  return <ConversationDevBadge conversation={conversation} />;
}
